import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-head-edit",
  "use": "icon-head-edit-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-head-edit\"><path fill-rule=\"evenodd\" d=\"M13.708 2.756a1.667 1.667 0 0 0-2.357 0l-8.595 8.595a1.667 1.667 0 0 0-.488 1.179v4.36c0 .465.377.842.842.842h13.328a.833.833 0 0 0 0-1.667h-6.61l7.416-7.416c.65-.651.65-1.706 0-2.357l-3.536-3.536ZM7.471 16.065l8.594-8.595-3.535-3.535-8.595 8.595v3.535H7.47Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol